import {Component} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {BackgroundCardComponent} from '../../../shared/components/titled-background-card/background-card.component';
import {DashboardOverviewComponent} from './dashboard-overview/dashboard-overview.component';
import {ProjectOverviewComponent} from './project-overview/project-overview.component';

@Component({
  selector: 'app-selecthor-admin-dashboard',
  templateUrl: './selecthor-admin-dashboard.component.html',
  imports: [
    TranslocoPipe,
    BackgroundCardComponent,
    DashboardOverviewComponent,
    ProjectOverviewComponent,
  ],
})
export class SelecthorAdminDashboardComponent {}
